export const videos = [
  {
    id: "v-g1",
    title: "王者荣耀巅峰对决：五杀收割全记录",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20esports%20arena%20scene%20with%20glowing%20orange%20accents%2C%20mobile%20MOBA%20hero%20silhouettes%20clashing%20in%20a%20fantasy%20battlefield%2C%20cinematic%20dramatic%20lighting%2C%20high%20contrast%20digital%20illustration%2C%20clean%20composition&width=640&height=360&seq=zb-g1-2026&orientation=landscape",
    category: "game",
    subcategory: "MOBA",
    streamerId: "s01",
    streamerName: "星野电竞",
    streamerAvatar: "星",
    popularity: "high",
    duration: 1465,
    views: 1284000,
    likes: 76200,
    publishedAt: "2026-10-11",
    description:
      "本场为赛季高分段巅峰对局，主播使用刺客英雄在中后期连续完成三波团战收割，最终达成五杀。视频完整保留了全程解说，重点复盘了进场时机的判断、技能连招的细节以及视野布置思路，适合想要提升团战意识的玩家反复观看。",
    tags: ["王者荣耀", "五杀", "高分段", "团战复盘"],
  },
  {
    id: "v-g2",
    title: "英雄联盟排位逆风翻盘教学局",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20fantasy%20battle%20arena%20with%20orange%20rim%20light%2C%20two%20armored%20champions%20facing%20off%20on%20a%20magical%20lane%2C%20moody%20cinematic%20lighting%2C%20high%20contrast%20game%20key%20art%20style%2C%20clean%20dark%20background&width=640&height=360&seq=zb-g2-2026&orientation=landscape",
    category: "game",
    subcategory: "MOBA",
    streamerId: "s02",
    streamerName: "蓝焰联盟",
    streamerAvatar: "蓝",
    popularity: "mid",
    duration: 2280,
    views: 642000,
    likes: 39800,
    publishedAt: "2026-10-08",
    description:
      "开局落后七个人头，主播没有放弃，通过稳健的兵线运营和一次关键的大龙决策完成翻盘。视频逐段标注了每一步选择的理由，是一期面向中低分段的实操教学，重点讲解如何在逆风局中保持节奏与心态。",
    tags: ["英雄联盟", "逆风翻盘", "排位教学", "运营"],
  },
  {
    id: "v-g3",
    title: "CS2 精准爆头集锦：一枪入魂",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20tactical%20shooter%20scene%20with%20warm%20orange%20muzzle%20flash%2C%20silhouette%20of%20an%20operative%20holding%20a%20rifle%20in%20a%20dusty%20urban%20map%2C%20cinematic%20high%20contrast%20lighting%2C%20modern%20game%20key%20art%20style&width=640&height=360&seq=zb-g3-2026&orientation=landscape",
    category: "game",
    subcategory: "FPS",
    streamerId: "s03",
    streamerName: "枪神阿凯",
    streamerAvatar: "凯",
    popularity: "high",
    duration: 912,
    views: 1573000,
    likes: 98400,
    publishedAt: "2026-10-12",
    description:
      "精选了本月直播中最精彩的爆头瞬间，包含手枪局一挑四、狙击枪空中转身击杀等名场面。视频配有慢动作回放和准星轨迹标注，方便观众观察压枪与预瞄的细节，是 FPS 玩家提升枪法的实用素材。",
    tags: ["CS2", "爆头", "集锦", "枪法"],
  },
  {
    id: "v-g4",
    title: "无畏契约残局一挑三冷静处理",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20cyber%20tactical%20shooter%20environment%20with%20orange%20holographic%20markers%2C%20lone%20agent%20holding%20position%20in%20a%20neon%20lit%20corridor%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20digital%20art&width=640&height=360&seq=zb-g4-2026&orientation=landscape",
    category: "game",
    subcategory: "FPS",
    streamerId: "s04",
    streamerName: "夜鹰Nova",
    streamerAvatar: "N",
    popularity: "mid",
    duration: 1038,
    views: 487000,
    likes: 31200,
    publishedAt: "2026-10-05",
    description:
      "决胜局 1v3 的经典残局，主播利用技能信息差逐个击破对手。视频中详细解说了听声辨位、假动作诱敌与换弹时机的选择，展现了高水平的临场决策能力，值得反复揣摩学习。",
    tags: ["无畏契约", "残局", "一挑三", "意识"],
  },
  {
    id: "v-g5",
    title: "星际争霸2 速攻流实战演示",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20sci%20fi%20strategy%20hologram%20with%20orange%20grid%20lines%2C%20futuristic%20command%20base%20and%20fleets%20of%20units%20over%20a%20planet%2C%20cinematic%20dramatic%20lighting%2C%20high%20contrast%20digital%20illustration&width=640&height=360&seq=zb-g5-2026&orientation=landscape",
    category: "game",
    subcategory: "即时战略",
    streamerId: "s05",
    streamerName: "战术指挥官",
    streamerAvatar: "战",
    popularity: "low",
    duration: 3120,
    views: 128000,
    likes: 8600,
    publishedAt: "2026-09-29",
    description:
      "一期面向入门玩家的速攻流派教学，从前期的建筑顺序到中期的骚扰节奏逐一拆解。主播用最朴实的操作展示了如何在十分钟内建立经济与兵力优势，帮助新手快速理解即时战略的核心思路。",
    tags: ["星际争霸2", "速攻", "战术", "入门教学"],
  },
  {
    id: "v-g6",
    title: "帝国时代4 文明速通全流程",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20medieval%20strategy%20illustration%20with%20orange%20torchlight%2C%20ancient%20stone%20castle%20and%20armies%20on%20a%20painted%20map%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20game%20key%20art%20style&width=640&height=360&seq=zb-g6-2026&orientation=landscape",
    category: "game",
    subcategory: "即时战略",
    streamerId: "s06",
    streamerName: "老张策略",
    streamerAvatar: "张",
    popularity: "low",
    duration: 4140,
    views: 96500,
    likes: 6400,
    publishedAt: "2026-09-21",
    description:
      "完整记录了一次高难度文明速通挑战。主播在前中期精准卡时间点升级时代，并用最短路径完成任务目标。视频保留了全部失误与补救过程，真实呈现了速通背后的思路与耐心。",
    tags: ["帝国时代4", "速通", "文明", "全流程"],
  },
  {
    id: "v-g7",
    title: "我的世界极限生存第100天",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20blocky%20voxel%20survival%20world%20with%20orange%20sunset%20glow%2C%20small%20character%20standing%20before%20a%20built%20fortress%20in%20a%20square%20terrain%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20digital%20art&width=640&height=360&seq=zb-g7-2026&orientation=landscape",
    category: "game",
    subcategory: "沙盒生存",
    streamerId: "s07",
    streamerName: "方块小宇",
    streamerAvatar: "宇",
    popularity: "high",
    duration: 3620,
    views: 2045000,
    likes: 158600,
    publishedAt: "2026-10-13",
    description:
      "极限生存系列迎来第 100 天，主播已经建立起完整的自动化农场与防御工事。本期视频回顾了从第一天到第一百天的关键节点，并开启了下矿洞寻找稀有矿石的新挑战，全程解说轻松有趣。",
    tags: ["我的世界", "极限生存", "第100天", "建造"],
  },
  {
    id: "v-g8",
    title: "泰拉瑞亚全成就挑战实况",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20pixel%20adventure%20world%20scene%20with%20orange%20lantern%20light%2C%20tiny%20hero%20exploring%20a%20cavern%20with%20glowing%20crystals%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20game%20key%20art&width=640&height=360&seq=zb-g8-2026&orientation=landscape",
    category: "game",
    subcategory: "沙盒生存",
    streamerId: "s08",
    streamerName: "冒险家Luna",
    streamerAvatar: "L",
    popularity: "mid",
    duration: 2760,
    views: 318000,
    likes: 21400,
    publishedAt: "2026-10-02",
    description:
      "向着全成就目标稳步推进的一期实况。主播接连挑战了数个高难度 Boss，并在过程中分享了装备搭配与走位技巧。视频节奏紧凑，适合喜欢沙盒冒险的观众一次看过瘾。",
    tags: ["泰拉瑞亚", "全成就", "Boss战", "实况"],
  },
  {
    id: "v-e1",
    title: "深夜吐槽大会：打工人的一周",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20cozy%20night%20studio%20scene%20with%20warm%20orange%20lamp%20light%2C%20empty%20microphone%20on%20a%20desk%20and%20a%20stool%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photography%20style&width=640&height=360&seq=zb-e1-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "脱口秀",
    streamerId: "s09",
    streamerName: "段子手小北",
    streamerAvatar: "北",
    popularity: "high",
    duration: 3540,
    views: 1731000,
    likes: 121300,
    publishedAt: "2026-10-12",
    description:
      "本期以打工人周一至周五的真实体验为主线，用密集的段子和自嘲把日常小崩溃讲得又好笑又治愈。直播间的实时弹幕互动也被剪进片中，让整场节奏更加轻快，深夜提神首选。",
    tags: ["脱口秀", "吐槽", "打工人", "解压"],
  },
  {
    id: "v-e2",
    title: "即兴喜剧现场翻车合集",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20small%20comedy%20stage%20with%20orange%20spotlight%2C%20two%20performers%20mid%20scene%20on%20an%20empty%20set%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photography%20style&width=640&height=360&seq=zb-e2-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "脱口秀",
    streamerId: "s10",
    streamerName: "快乐制造机",
    streamerAvatar: "乐",
    popularity: "mid",
    duration: 1980,
    views: 526000,
    likes: 35200,
    publishedAt: "2026-10-06",
    description:
      "即兴喜剧最精彩的部分往往来自意外。本期收集了直播中数次忘词、接梗失败又神级救场的瞬间，配上主播毫不掩饰的自我调侃，笑点密集，全程高能不断。",
    tags: ["即兴喜剧", "翻车", "名场面", "欢乐"],
  },
  {
    id: "v-e3",
    title: "城市夜骑第一视角体验",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20city%20street%20at%20night%20with%20warm%20orange%20street%20lights%2C%20first%20person%20view%20along%20an%20empty%20road%20toward%20a%20glowing%20skyline%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20photography&width=640&height=360&seq=zb-e3-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "户外",
    streamerId: "s11",
    streamerName: "户外阿泽",
    streamerAvatar: "泽",
    popularity: "mid",
    duration: 2640,
    views: 398000,
    likes: 24600,
    publishedAt: "2026-10-03",
    description:
      "带上运动相机，主播在深夜的城市里骑行十二公里，途经老城区、跨江大桥与滨江步道。视频用第一视角完整呈现沿途的灯光与夜景，配合现场环境音，带来沉浸式的城市夜游体验。",
    tags: ["户外", "夜骑", "第一视角", "城市"],
  },
  {
    id: "v-e4",
    title: "海边露营星空直播实录",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20seaside%20campsite%20at%20night%20with%20warm%20orange%20campfire%20glow%2C%20a%20small%20tent%20under%20a%20starry%20sky%20beside%20calm%20water%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20photography&width=640&height=360&seq=zb-e4-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "户外",
    streamerId: "s12",
    streamerName: "露营小分队",
    streamerAvatar: "营",
    popularity: "low",
    duration: 5400,
    views: 142000,
    likes: 10800,
    publishedAt: "2026-09-26",
    description:
      "一次安静的海边露营慢直播。从傍晚搭帐篷、生火做饭，到深夜躺在防潮垫上看星星，主播用舒缓的语速陪伴观众度过了一个放松的夜晚。适合睡前静静观看，缓解一天的疲惫。",
    tags: ["露营", "星空", "慢直播", "治愈"],
  },
  {
    id: "v-e5",
    title: "粉丝互动名场面合集",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20streaming%20desk%20setup%20with%20warm%20orange%20rgb%20backlight%2C%20empty%20gaming%20chair%20and%20headset%20in%20a%20dim%20studio%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photo&width=640&height=360&seq=zb-e5-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "搞笑",
    streamerId: "s13",
    streamerName: "逗趣大熊",
    streamerAvatar: "熊",
    popularity: "high",
    duration: 2220,
    views: 1408000,
    likes: 97300,
    publishedAt: "2026-10-10",
    description:
      "从抽奖互动到真心话大冒险，本期精选了粉丝互动环节最出圈的瞬间。主播随机连麦、现场立 flag 又光速打脸，笑料源源不断。想了解直播间氛围的观众千万别错过。",
    tags: ["粉丝互动", "名场面", "搞笑", "连麦"],
  },
  {
    id: "v-e6",
    title: "连麦翻车笑到停不下来",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20podcast%20booth%20at%20night%20with%20warm%20orange%20accent%20light%2C%20two%20microphones%20facing%20each%20other%20on%20a%20desk%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photography%20style&width=640&height=360&seq=zb-e6-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "搞笑",
    streamerId: "s14",
    streamerName: "开心果酱",
    streamerAvatar: "酱",
    popularity: "mid",
    duration: 1860,
    views: 611000,
    likes: 42900,
    publishedAt: "2026-09-30",
    description:
      "一次看似普通的粉丝连麦，却因为网络卡顿、口音误会和神级发言连续翻车。主播全程强忍笑意努力控场，结果越解释越好笑。本期完整还原了事故现场，笑果扎实。",
    tags: ["连麦", "翻车", "搞笑", "直播切片"],
  },
  {
    id: "v-e7",
    title: "深夜电台点歌专场",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20late%20night%20radio%20studio%20with%20warm%20orange%20desk%20lamp%2C%20vintage%20turntable%20and%20headphones%20on%20a%20wooden%20desk%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photo&width=640&height=360&seq=zb-e7-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "音乐现场",
    streamerId: "s15",
    streamerName: "电台阿Moon",
    streamerAvatar: "M",
    popularity: "mid",
    duration: 4380,
    views: 289000,
    likes: 20100,
    publishedAt: "2026-09-24",
    description:
      "深夜点歌台准时开播，主播根据弹幕点歌顺序播放并讲述每首歌背后的故事。期间穿插了听众的来信与祝福，气氛温柔安静。适合在深夜工作或失眠时当作陪伴背景音。",
    tags: ["电台", "点歌", "深夜", "陪伴"],
  },
  {
    id: "v-e8",
    title: "卧室音乐会现场版",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20cozy%20bedroom%20live%20session%20with%20warm%20orange%20string%20lights%2C%20acoustic%20guitar%20leaning%20against%20a%20soft%20chair%20at%20night%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photo&width=640&height=360&seq=zb-e8-2026&orientation=landscape",
    category: "entertainment",
    subcategory: "音乐现场",
    streamerId: "s16",
    streamerName: "木吉他小林",
    streamerAvatar: "林",
    popularity: "low",
    duration: 3000,
    views: 118000,
    likes: 9200,
    publishedAt: "2026-09-18",
    description:
      "没有华丽舞台，只有一把木吉他和一间点着小灯的卧室。主播用最朴素的编制翻唱了十几首民谣与流行歌，全程一镜到底不做剪辑，保留了呼吸与走音的细节，真实又动人。",
    tags: ["音乐会", "翻唱", "民谣", "不插电"],
  },
  {
    id: "v-t1",
    title: "高音挑战：从凌晨唱到天亮",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20stage%20with%20warm%20orange%20spotlight%20beams%2C%20a%20female%20singer%20silhouette%20holding%20a%20microphone%20mid%20high%20note%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20concert%20photography&width=640&height=360&seq=zb-t1-2026&orientation=landscape",
    category: "talent",
    subcategory: "唱歌",
    streamerId: "s17",
    streamerName: "天籁小柔",
    streamerAvatar: "柔",
    popularity: "high",
    duration: 5120,
    views: 1896000,
    likes: 143200,
    publishedAt: "2026-10-09",
    description:
      "一场持续数小时的高音挑战直播。主播从深夜唱到天微微亮，连续演唱了多首高难度歌曲，中途几次险些破音又被稳稳拉回。视频保留了完整的演唱顺序与观众投票环节，极具现场感。",
    tags: ["高音挑战", "唱歌", "直播实录", "现场"],
  },
  {
    id: "v-t2",
    title: "粉丝点歌清唱名场面",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20intimate%20studio%20with%20warm%20orange%20accent%20lighting%2C%20a%20microphone%20on%20a%20stand%20with%20soft%20bokeh%20background%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20portrait%20photography&width=640&height=360&seq=zb-t2-2026&orientation=landscape",
    category: "talent",
    subcategory: "唱歌",
    streamerId: "s18",
    streamerName: "清唱阿泽",
    streamerAvatar: "清",
    popularity: "mid",
    duration: 2460,
    views: 734000,
    likes: 51200,
    publishedAt: "2026-10-01",
    description:
      "完全依赖人声的无伴奏清唱专场，主播根据粉丝实时点歌即兴演唱。没有伴奏的遮掩，音准与节奏全部暴露，反而更显功底。本期收录了现场观众呼声最高的十首歌。",
    tags: ["清唱", "点歌", "无伴奏", "功底"],
  },
  {
    id: "v-t3",
    title: "国风爵士编舞练习室",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20dance%20studio%20with%20warm%20orange%20backlight%2C%20mirrored%20wall%20and%20a%20dancer%20freezing%20mid%20movement%20in%20flowing%20costume%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20photo&width=640&height=360&seq=zb-t3-2026&orientation=landscape",
    category: "talent",
    subcategory: "舞蹈",
    streamerId: "s19",
    streamerName: "舞者小鹿",
    streamerAvatar: "鹿",
    popularity: "high",
    duration: 1740,
    views: 1122000,
    likes: 88600,
    publishedAt: "2026-10-07",
    description:
      "本期带来一段将国风身韵与爵士律动融合的原创编舞。主播在练习室完整演示了整支舞蹈，并拆分讲解了几个转体与point动作的发力要点，喜欢舞蹈的观众可以跟着一起练习。",
    tags: ["舞蹈", "国风爵士", "编舞", "练习室"],
  },
  {
    id: "v-t4",
    title: "街舞Battle高光时刻",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20underground%20dance%20battle%20space%20with%20warm%20orange%20spotlights%2C%20two%20dancers%20facing%20off%20on%20a%20concrete%20floor%20surrounded%20by%20crowd%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20photo&width=640&height=360&seq=zb-t4-2026&orientation=landscape",
    category: "talent",
    subcategory: "舞蹈",
    streamerId: "s20",
    streamerName: "街舞阿King",
    streamerAvatar: "K",
    popularity: "mid",
    duration: 2100,
    views: 456000,
    likes: 33800,
    publishedAt: "2026-09-27",
    description:
      "一次线下街舞交流赛的完整记录。主播在多轮 Battle 中先后使用 Popping 与 Breaking，与对手展开激烈对决。视频保留了裁判点评与现场反应，充分展现了街舞文化里以舞会友的氛围。",
    tags: ["街舞", "battle", "高光", "线下"],
  },
  {
    id: "v-t5",
    title: "钢琴即兴改编热门歌曲",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20grand%20piano%20on%20a%20dim%20stage%20with%20warm%20orange%20side%20lighting%2C%20elegant%20keys%20and%20a%20soft%20glow%2C%20cinematic%20moody%20atmosphere%2C%20high%20contrast%20editorial%20photography&width=640&height=360&seq=zb-t5-2026&orientation=landscape",
    category: "talent",
    subcategory: "乐器",
    streamerId: "s21",
    streamerName: "琴键先生",
    streamerAvatar: "琴",
    popularity: "mid",
    duration: 2340,
    views: 372000,
    likes: 26800,
    publishedAt: "2026-09-25",
    description:
      "主播现场抽取热门歌曲主题，用钢琴进行即兴改编。从旋律变奏到和声重构，每一步都在镜头前完成，边弹边讲解思路。即使不懂乐理，也能感受到音乐被重新排列的乐趣。",
    tags: ["钢琴", "即兴", "改编", "演奏"],
  },
  {
    id: "v-t6",
    title: "古筝演奏古风曲目合集",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20traditional%20chinese%20interior%20with%20warm%20orange%20lantern%20light%2C%20an%20elegant%20guzheng%20on%20a%20wooden%20stand%20beside%20a%20screen%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photo&width=640&height=360&seq=zb-t6-2026&orientation=landscape",
    category: "talent",
    subcategory: "乐器",
    streamerId: "s22",
    streamerName: "弦月姑娘",
    streamerAvatar: "弦",
    popularity: "low",
    duration: 2880,
    views: 156000,
    likes: 12400,
    publishedAt: "2026-09-20",
    description:
      "用古筝演绎一组经典古风曲目，涵盖影视配乐与网络热门国风歌。主播在演奏间隙分享了曲目的背景故事，并介绍了古筝的指法与韵味。整体氛围雅致安静，适合静心聆听。",
    tags: ["古筝", "古风", "演奏", "国乐"],
  },
  {
    id: "v-t7",
    title: "三小时画出赛博都市",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20digital%20art%20workspace%20with%20warm%20orange%20glow%2C%20drawing%20tablet%20and%20stylus%20on%20a%20desk%20showing%20a%20cyber%20city%20sketch%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photo&width=640&height=360&seq=zb-t7-2026&orientation=landscape",
    category: "talent",
    subcategory: "绘画",
    streamerId: "s23",
    streamerName: "画笔老李",
    streamerAvatar: "李",
    popularity: "low",
    duration: 10800,
    views: 98000,
    likes: 8100,
    publishedAt: "2026-09-19",
    description:
      "从上色稿到完成一张赛博朋克风格的都市插画，主播全程无剪辑记录了近三个小时的绘制过程。视频用加速与关键帧标注的方式呈现构图、光影与细节刻画，适合想学场景绘画的观众参考。",
    tags: ["绘画", "插画", "赛博朋克", "过程"],
  },
  {
    id: "v-t8",
    title: "板绘人物全过程记录",
    cover: "https://readdy.ai/api/search-image?query=dark%20navy%20illustrator%20desk%20with%20warm%20orange%20lamp%2C%20digital%20tablet%20showing%20a%20character%20line%20art%20in%20progress%20beside%20art%20supplies%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20editorial%20photo&width=640&height=360&seq=zb-t8-2026&orientation=landscape",
    category: "talent",
    subcategory: "绘画",
    streamerId: "s24",
    streamerName: "插画小满",
    streamerAvatar: "满",
    popularity: "mid",
    duration: 6600,
    views: 214000,
    likes: 17900,
    publishedAt: "2026-09-22",
    description:
      "一期完整的人物板绘教学实录，从草图、线稿到铺色、细化逐步推进。主播在关键步骤会停下来讲解人体结构与配色思路，并回答弹幕中的绘画问题，对新手非常友好。",
    tags: ["板绘", "人物", "教学", "插画"],
  },
];